<template>
  <div>
    <!-- 전체 예약 요청 내역 -->
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="조회"></admin-filter>


    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="id" slot-scope="props">
        <div @click="$router.push(`order_detail?id=${props.item.id}`)"
             style="cursor:pointer;text-decoration: underline">
          {{ props.item.order_num }}</div>
      </div>

      <div slot="product" slot-scope="props">
        {{ props.item.product.name }}
      </div>

      <div slot="resv_date" slot-scope="props">
        {{ props.item.resv_date }} <br/>
        {{ props.item.all_time ? '[종일]' : `${props.item.start_time.substring(0,5)} ~ ${props.item.end_time.substring(0,5)}`}}
      </div>

      <div slot="total_price" slot-scope="props">
        <div>{{ props.item.total_price | currency }}</div>
      </div>

      <div slot="is_read" slot-scope="props">
        <div v-if="props.item.is_read">확인</div>
        <div v-else>미확인</div>
      </div>

      <div slot="order_status_kor" slot-scope="props">
        <div>{{ props.item.no_show ? '노쇼' : props.item.order_status_kor }}</div>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <div v-if="props.item.status===100 || props.item.status===101">
          <button class="button half" style="margin-right:4px" @click="openModal(props.item, 200, '확정')">확정</button>
          <button class="button half" @click="openModal(props.item, 402, '취소')">취소</button>
        </div>
        <div v-else>-</div>
      </div>
    </admin-table>

    <modal name="statusChangeModal" :adaptive="true" :width="800" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div><span v-if="selectedItem.name">{{ selectedItem.name }}님</span> 예약을 {{ selectedItem.title }} 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('statusChangeModal')">취소</button>
          <button class="button is-primary" @click="statusChange">확인</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import ReservationMixin from '@/mixins/ReservationMixin'
  export default {
    name: "OrderListAll",
    mixins: [
      ReservationMixin
    ],
    created() {
      this.init();
    },
    methods: {
      init() {
        this.initializing('order_list_all', 'reservation/order');

        if(!this.isAdmin) {
          this.tableData = this.tableData.filter(item => {
            return ['partner', 'is_read'].indexOf(item.eng_name) === -1;
          });
        }
      },
      getDataFromServer() {
        this.getData();
      },
    }
  }
</script>
